"use client";

import { Check, Copy } from "lucide-react";
import { useRef, useState } from "react";
import { CopyButtonProps } from "@/lib/types";
import { Button } from "@/components/catalyst/button";
import { toast } from "sonner";

export function CopyButton(props: CopyButtonProps) {
  const { text } = props;
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(0);

  const onClick = async () => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    toast.success("Copied to clipboard!");
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <Button
      outline
      type="button"
      className={`absolute top-2 right-2 z-1 !size-10 px-2 py-1.5 text-xs backdrop-blur-md ${
        copied ? "bg-green-100 text-green-600" : "text-foreground"
      }`}
      name="Copy to clipboard"
      aria-label="Copy to clipboard"
      onClick={onClick}
    >
      {copied ? <Check className="size-3" /> : <Copy className="size-3" />}
    </Button>
  );
}
